import { render, staticRenderFns } from "./VouchersList.vue?vue&type=template&id=4549dff4&"
import script from "./VouchersList.vue?vue&type=script&lang=js&"
export * from "./VouchersList.vue?vue&type=script&lang=js&"
import style0 from "./VouchersList.vue?vue&type=style&index=0&id=4549dff4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports